module.exports = __webpack_public_path__ + "static/19-6b0f760130f04b0e754fff05145cfdfe.png";